import { pipe, constVoid } from 'fp-ts/function';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { FullWidthFieldsContainer, ResponsiveFormElement } from '@mews-commander/ui';
import { commanderForm, InputField } from '@mews-commander/legacy-form';
import { undoCheckIn, undoCheckOut } from '../actions';

const inputFieldProps = {
    label: <LocalizedText textKey={TextKey.ReservationDetailReasonInputLabel} />,
    name: 'reason',
};

const UndoCheckInOutForm = () => (
    <FullWidthFieldsContainer>
        <InputField {...inputFieldProps} />
    </FullWidthFieldsContainer>
);

interface UndoCheckInOutValues {
    reason: string;
}
interface DispatchProps {
    onSubmit: (values: UndoCheckInOutValues) => void;
}
interface OwnProps {
    onSuccess?: () => void;
    reservationIds: string[];
}

const undoCheckInOutFactory = ({ submitAction }: $TSFixMe) =>
    pipe(
        UndoCheckInOutForm,
        commanderForm<UndoCheckInOutValues, {}>({
            enableReinitialize: true,
            submitLabel: <LocalizedText textKey={TextKey.Undo} />,
            submitButtonProps: {
                'data-test-id': DataTestId.UndoButton,
            },
            FormElement: ResponsiveFormElement,
        }),
        connect<{}, DispatchProps, OwnProps>(undefined, (dispatch, { reservationIds, onSuccess = constVoid }) => ({
            onSubmit: ({ reason }) => dispatch(submitAction(reservationIds, reason)).then(onSuccess),
        }))
    );

export const UndoCheckInForm = undoCheckInOutFactory({ submitAction: undoCheckIn });
export const UndoCheckOutForm = undoCheckInOutFactory({ submitAction: undoCheckOut });
